import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
interface IProps {
    title: string
    active: boolean
    children: React.ReactNode
}

const SideNavMenuSection = ({ title, active, children }: IProps) => {
    const [isActive, setIsActive] = useState<boolean>(active)

    useEffect(() => {
        setIsActive(active)
    }, [title, active, children])

    return (
        <div className='w-100'>
            <button
                onClick={() => setIsActive(!isActive)}
                className={isActive ? 'dropdown-btn active' : 'dropdown-btn'}
            >
                <span className='float-start'>{title}</span>
                <span className='float-end me-2'>
                    <FontAwesomeIcon
                        color={isActive ? 'white' : 'gray'}
                        icon={['fas', isActive ? 'caret-up' : 'caret-down']}
                    />
                </span>
            </button>
            <div className='dropdown-container' style={{ display: isActive ? 'block' : 'none' }}>
                {children}
            </div>
        </div>
    )
}

export default SideNavMenuSection